import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {func, object, string} from 'prop-types';
import React, {useCallback, useState} from 'react';

export const ALL = '';
export const DRAFT = 'false';
export const PUBLISHED = 'true';

const statuses = [ALL, PUBLISHED, DRAFT];
const labels = {
  [ALL]: 'include draft',
  [DRAFT]: 'draft only',
  [PUBLISHED]: 'published only',
};

function Status({sx, onChange, value}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !!anchorEl;

  const onButtonClick = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const onMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const onMenuItemClick = useCallback(
    (event, newValue) => {
      onChange(newValue);
      setAnchorEl(null);
    },
    [onChange],
  );

  const status = value in labels ? value : ALL;
  const label = labels[status];
  const color = status !== ALL ? 'primary' : 'secondary';

  return (
    <Box sx={sx}>
      <Button
        onClick={onButtonClick}
        variant="outlined"
        size="small"
        color={color}
        endIcon={<ArrowDropDownIcon />}
      >
        {label}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={onMenuClose}>
        {statuses.map(s => (
          <MenuItem
            key={s}
            onClick={event => onMenuItemClick(event, s)}
            dense
            sx={{textTransform: 'uppercase'}}
          >
            {labels[s]}
            <ListItemIcon sx={{marginLeft: 2}}>
              {s === status ? <CheckIcon fontSize="small" /> : null}
            </ListItemIcon>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}

Status.propTypes = {
  sx: object,
  onChange: func.isRequired,
  value: string,
};

export default Status;
